import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Theme1 } from '../../theme/theme'

export const StyledNavLink = styled(NavLink)`
  color: ${Theme1.colors.text.defaultLight};
  text-decoration: none;
  font-weight: 600;
`
